var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIconNavi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9911 4.30352L4.65691 7.08165C4.36469 7.17906 4.20675 7.49493 4.30416 7.78716C4.35021 7.92529 4.44843 8.03994 4.57786 8.10661L7.76893 9.75053C7.97532 9.85685 8.1434 10.0249 8.24972 10.2313L9.8936 13.4225C10.0347 13.6963 10.371 13.8039 10.6448 13.6629C10.7743 13.5962 10.8725 13.4815 10.9185 13.3434L13.6966 5.00904C13.794 4.7168 13.6361 4.40094 13.3439 4.30352C13.2294 4.26536 13.1056 4.26536 12.9911 4.30352Z"
  })));
}
export default SvgPlaceIconNavi;